import ServiceAssignmentRulesBaseController from '../common/service_assignment_rules.base.controller'

class ServiceAssignmentRulesEditController extends ServiceAssignmentRulesBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, Modal, $translate, $stateParams, $q) {
        super();
        // super(Auth, $state, User, ServiceAssignmentRulesService, Modal, $translate, $stateParams)
        this.$stateParams = $stateParams;
        this.$q = $q;
        this.User = User;
        this.hasACL = {};
        this.rawId = '';

        this.defaultModel = {};
        this.loading = false;
        this.model = angular.copy(this.defaultModel);
        this.branchId = this.User.getUser().branchId;
    }

    $onInit() {
    }

    reset() {

    }

    submit() {
    }
}

export default ServiceAssignmentRulesEditController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/service_assignment_rules/edit/service_assignment_rules.edit.controller.js